<!-- 采购计划 -->
<template>
   <div class='page_content'>
      <purchasePlanAction ref="purchasePlanAction" @addClick='addClick'></purchasePlanAction>
      <purchasePlanAutoAction ref="purchasePlanAutoAction"></purchasePlanAutoAction>

      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
               <template slot="searchInput" slot-scope="{formOneValue}">
                  <!-- 业务员	 -->
                  <el-input v-if="formOneValue.entityField == 'pspmBuycus'" @focus="$refs['showSelectData'].openBox('supplierList', 'supplier', '')" v-model.trim="getRequestData.smName" clearable
                            :maxlength="$store.state.inputLength">
                  </el-input>
               </template>
            </vSearch>
         </div>
      </div>
      <div class="page_content_center">
         <el-table ref="minTable" v-if="pageShowData.jurTableVo" @selection-change="handleSelectionChange" @cell-dblclick="changeInput" stripe :data="returnData.searchList" :height="tableHeight"
                   :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
            <el-table-column align="center" type="selection" width="50"></el-table-column>
            <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" :prop="tableValye.entityField"
                             :label="tableValye.showField" :min-width="tableValye.fieldWeight" show-overflow-tooltip>
               <template slot-scope="scope">
                  <div v-if="tableValye.entityField == 'pspmState'">
                     {{ scope.row.pspmState == 0 ? '初始' : '已转为订单' }}
                  </div>
                  <div v-else-if="tableValye.entityField == 'pspmSdate'">
                     {{ $common.getLocalTime(scope.row.pspmSdate) }}
                  </div>
                  <div v-else-if="tableValye.entityField == 'pspmEdate'">
                     {{ $common.getLocalTime(scope.row.pspmEdate) }}
                  </div>
                  <div v-else-if="tableValye.fieldType == 'date'">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </div>
                  <div v-else-if="tableValye.entityField == 'lackNum'">
                     <el-input v-if="scope.row.edit" v-model="scope.row.lackNum" @blur="blurUpdate(scope.row)"></el-input>
                     <span v-else>{{ scope.row.lackNum }}</span>
                  </div>
                  <div v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </div>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :oneFlag="true" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth">
         <ExtractionScheme ref="extractionScheme" :id="exId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import { openDB, read, getAll } from "@/byComponents/indexdb.js";
import SearchScheme from "../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../byComponents/ExtractionScheme.vue";
import purchasePlanAutoAction from "@/components/purchasePlanAutoAction.vue";
import purchasePlanAction from "@/components/purchasePlanAction.vue";

export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
      purchasePlanAutoAction,
      purchasePlanAction
   },
   data() {
      //这里存放数据
      return {
         exId: "1",
         seId: "51",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         tableHeight: 0,
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         formObj: {},
         chenform: {},
         tableData: [],
         getRequestData: {
            pspmBuycus: "",
            bgmName: "",
            page: 1,
            rows: 30,
            start: "",
            end: "",
         },
         requestData: {},
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
            filterList: [],
            searchList: [],
         },
         buttonList: [],
         multipleSelection: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         selectedDetailsDataIndex: "",
         parentSearchData: {},
         midSelectData: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.pspmBuycus = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      addClick(val) {
         var arr = JSON.parse(JSON.stringify(val))
         this.returnData.list.push(...arr)
         if (this.returnData.list.length < 1) {
            this.$message({
               message: '暂无数据',
               type: "error",
            });
         }
         this.returnData.filterList = JSON.parse(JSON.stringify(this.returnData.list));
         this.returnData.filterList.forEach(v => {
            v["edit"] = false;
         })
         this.returnData.searchList = JSON.parse(JSON.stringify(this.returnData.filterList));
         this.selectedDataIndex = 0;
         this.$refs['purchasePlanAction'].initActionBox()
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)

         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      blurUpdate(row) {
         row['edit'] = false
      },
      changeInput(row) {
         // console.log('changeInput', row);
         row['edit'] = true
         this.returnData.searchList.splice(1, 0)
         // this.$refs.minTable.doLayout()
      },
      // 勾选明细
      handleSelectionChange(val) {
         this.multipleSelection = val;
         this.midSelectData = JSON.parse(JSON.stringify(val))
      },
      //检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.getRequestData[type]

      },
      openSearchs() {
         this.DialogVisible = true;
         this.seId = 938329237748374;
         this.seType = '提取缺货登记';
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seType == '提取缺货登记') {
               this.bgmSelect(val)
            }
         }
         this.ceshi = val.rrmCreatetime;
      },
      bgmSelect(val) {
         if (this.returnData.searchList.length > 0) {
            var mx = JSON.parse(JSON.stringify(val))
            this.returnData.searchList.forEach(item => {
               var index = mx.findIndex(value => value.wolrId===item.wolrId)
               console.log(index);
               
               if (index != -1) {
                  mx.splice(index, 1)
               }
            })
            mx.forEach(item => {
               this.returnData.searchList.push({})
               var selextIndex = this.returnData.searchList.length - 1
               for (const key in this.formObj) {
                  if (item[key] != undefined && item[key] != "" && item[key] != null) {
                     this.$set(this.returnData.searchList[selextIndex], key, item[key])
                  }
               }
            })
         } else {
            this.returnData.searchList = []
            var mx = JSON.parse(JSON.stringify(val))
            mx.forEach(item => {
               this.returnData.searchList.push({})
               var selextIndex = this.returnData.searchList.length - 1
               for (const key in this.formObj) {
                  if (item[key] != undefined && item[key] != "" && item[key] != null) {
                     this.$set(this.returnData.searchList[selextIndex], key, item[key])
                  }
               }
            })
         }

      },
      getDataByChen(val) {
         console.log(val);
         this.DialogExtract = false;
         this.tableData = val.arrlistbychen;
         this.chenform = val;
      },
      // 提取方案
      handleClickExtraction() {
         this.DialogExtract = true;
         this.exId = "1";
      },
      handleClickCeShi() {
         this.DialogExtract = true;
         this.exId = "2728738889732096";
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索方案
      handleClickEjectDialog() {
         this.DialogVisible = true;
         this.seId = "1123";
      },
      handleClickSearch() {
         this.DialogVisible = true;
         this.seId = "2728430943932416";
      },
      //   =----------------------------------------------------------------------------------
      selectedDetailsDataAction(data) {
         var info = data.split(",").map(Number);
         this.selectedDataIndex = info[0];
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList
            if (this.pageShowData.jurHead) {
               var obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
               for (const key in obj) {
                  this.$set(this.getRequestData, key, obj[key])
               }
            }
            this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
               if (item.fieldType == 'number') {
                  this.$set(this.formObj, item.entityField, 0)
               } else {
                  this.$set(this.formObj, item.entityField, "")
               }
            })
            this.getData()
            this.getButtonList()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async getData(val) {
         this.returnData.list = []
         this.returnData.filterList = []
         this.returnData.searchList = []

         if (val) {
            this.requestData = JSON.parse(JSON.stringify(val));
            var responseData = await this.$http.savePurchasePlan(this.requestData);
            if (responseData.status == 200) {
               this.returnData.list = responseData.result;
               if (this.returnData.list.length < 1) {
                  this.$message({
                     message: '暂无数据',
                     type: "error",
                  });
               }
               this.returnData.filterList = JSON.parse(JSON.stringify(this.returnData.list));
               this.returnData.filterList.forEach(v => {
                  v["edit"] = false;
               })
               this.returnData.searchList = JSON.parse(JSON.stringify(this.returnData.filterList));
               this.selectedDataIndex = 0;
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },


      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 1:
               this.$refs["purchasePlanAction"].openBox();
               break;
            case 1:
               // this.openActionBox(actionData.actionType)
               break;
            case 2:
               this.delDataAction();
               break;
            case 3:
               this.planToOrder();
               break;
            case 4:
               this.exportData();
               break;
            case 5:
               this.openSearchs();
               break;
            case 0:
               this.$refs["purchasePlanAutoAction"].openBox(
                  0,
                  this.formDataList,
                  "",
                  ""
               );
               break;
         }
      },
      //导出数据
      exportData() {
         // if (this.requestData.bgiType == undefined) return this.$message.error('请先查询缺货')
         if (this.returnData.searchList.length == 0) return this.$message.error('暂无数据')
         this.export2Excel()
         // console.log(`${this.$store.getters.getConfig.requestUrl}/pisplanorder/exportQuert_good?ormId=${JSON.parse(sessionStorage.getItem('ormId'))}&creater=${JSON.parse(sessionStorage.getItem('userInfo')).opmId}&bgiType=${this.requestData.bgiType || ''}&coId=${this.requestData.coId || ''}&coName=${this.requestData.coName || ''}&opmId=${this.requestData.opmId || ''}&opmName=${this.requestData.opmName || ''}&pspmEdate=${this.requestData.pspmEdate || ''}&pspmSdate=${this.requestData.pspmSdate || ''}&pspmSupdays=${this.requestData.pspmSupdays || ''}&smId=${this.requestData.smId || ''}&smName=${this.requestData.smName || ''}`);
         // return             **----------------------------- 
         // window.location.href = `${this.$store.getters.getConfig.requestUrl}/pisplanorder/exportQuert_good?ormId=${JSON.parse(sessionStorage.getItem('ormId'))}&creater=${JSON.parse(sessionStorage.getItem('userInfo')).opmId}&bgiType=${this.requestData.bgiType || ''}&coId=${this.requestData.coId || ''}&coName=${this.requestData.coName || ''}&opmId=${this.requestData.opmId || ''}&opmName=${this.requestData.opmName || ''}&pspmEdate=${this.requestData.pspmEdate || ''}&pspmSdate=${this.requestData.pspmSdate || ''}&pspmSupdays=${this.requestData.pspmSupdays || ''}&smId=${this.requestData.smId || ''}&smName=${this.requestData.smName || ''}`
      },
      //表格数据写入excel

      export2Excel() {
         var listBeiFen = JSON.parse(JSON.stringify(this.returnData.searchList))
         var nameList = []; //表格头 显示的所有字段
         var fieldList = []; //所有字段 显示的所有字段
         var timeList = []; //date类型的字段 导出之前进行格式转换
         var numList = []; //number类型的字段 导出之前进行格式转换
         var formatterList = []; //"formatter"类型字段，格式转换
         let formatterSel = []
         // 循环当前tab表格信息
         this.pageShowData.jurTableVo.jurconfigtable.forEach((item) => {
            // 显示的字段//表头
            if (item.isShow == 1) {
               nameList.push(item.showField);
               fieldList.push(item.entityField);
            }
            // 如果为date类型push
            if (item.fieldType == "date") {
               timeList.push(item.entityField);
            }
            // 如果为number类型push
            if (item.fieldType == "number") {
               numList.push(item.entityField);
            }
            //如果date类型为"formatter"
            if (item.fieldType == "formatter") {
               formatterSel.push(JSON.parse(item.formatterContent))
               formatterList.push(item.entityField)
            }

         });
         // 循环数据列表和时间字段数组 进行转换
         listBeiFen.forEach((item) => {
            timeList.forEach((timeitem) => {
               // && typeof item[timeitem] === 'number'
               if (item[timeitem]) {
                  let fmDate = this.$common.getLocalTime(item[timeitem])
                  item[timeitem] = fmDate.indexOf('-') > -1 ? fmDate : "";
               } else {
                  item[timeitem] = ""
               }
            });
         });
         //循环数据列表和formatter字段
         listBeiFen.forEach((item) => {
            for (let j = 0; j <= formatterList.length; j++) {
               if (item[formatterList[j]] != null) {
                  let num = JSON.parse(JSON.stringify(item[formatterList[j]]))
                  item[formatterList[j]] = formatterSel[j][num].value
               }
            }
         });
         numList.forEach(item => {
            listBeiFen.forEach(key => {
               key[item] = Number(key[item])
            })
         })
         // 导出业务逻辑 引用封装好的js方法
         require.ensure([], () => {
            const {
               export_json_to_excel
            } = require("@/assets/excel/Export2Excel");
            //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
            const tHeader = nameList; // 导出的excel表头名信息
            const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
            const list = listBeiFen; // 查询的数据list
            // 进行数据json map 格式转换
            const data = this.formatJson(filterVal, list);
            // 调用方法传参      表头名信息 数据  导出的表格名称
            export_json_to_excel(tHeader, data, "缺货记录列表");


         });
      },
      //格式转换方法
      formatJson(filterVal, jsonData) {
         return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
      // 数据搜索
      searchData() {
         this.returnData.searchList = [];
         // 抽取所有非空字符串搜索条件（每个搜索框对应一个字段，按字段名映射）
         const kws = {};
         Object.keys(this.getRequestData).forEach((k) => {
            const v = this.getRequestData[k];
            if (typeof v === 'string' && v.trim() !== '') {
               kws[k] = v.trim();
            }
         });
         // 任一非空搜索条件都需要在对应行字段中命中（AND 关系；全空显示全部）
         this.returnData.filterList.forEach((row) => {
            const allHit = Object.keys(kws).every((k) => row[k] != null && String(row[k]).indexOf(kws[k]) > -1);
            if (allHit) {
               this.returnData.searchList.push(JSON.parse(JSON.stringify(row)));
            }
         });
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getData();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getData();
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getPurchasePlan(this.getRequestData);
         if (responseData.status == 200) {

         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //  生成缺货记录 
      planToOrder() {
         // console.log('ggggg', this.requestData);
         if (this.multipleSelection.length < 1) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         this.$confirm("确定要生成缺货记录吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var ids = []
               this.multipleSelection.forEach(v => {
                  let item = JSON.parse(JSON.stringify(v))
                  item.smId = this.requestData.smId
                  ids.push(item)
               })
               let responseData = await this.$http.pisplanorderPlanAdd(ids);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "操作成功!",
                  });
                  this.requestData = {}
                  this.getData();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },

      // 删除数据
      delDataAction() {
         this.multipleSelection.forEach(v => {
            for (let i = 0; i < this.returnData.filterList.length; i++) {
               const child = this.returnData.filterList[i];
               if (v.bgmId === child.bgmId) {
                  this.returnData.filterList.splice(i, 1)
                  this.returnData.list.splice(i, 1)
                  break;
               }
            }
         })
         this.returnData.searchList = JSON.parse(JSON.stringify(this.returnData.filterList))
      },

      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
      this.getButtonList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      //监听自适应
      //  window.addEventListener('resize', this.tiao);
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight()
      })
   }, //生命周期 - 更新之后
   beforeDestroy() {
      // window.removeEventListener("resize", this.tiao);
   }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
</style>
